const messageState = {
    messageArray: [
        {
            number: 1233,
            message: "Szanowny Panie Premierze, zwracamy sie do Pana Premiera z apelem"
        },
        {
            number: 4242,
            message: "Petycja do klubów poselskich w sprawie natychmiastowej izolacji sprawców przemocy"
        },
        {
            number: 565,
            message: "Petycja do Rady Poselskiej o bezpładne wakacje dla dzieci dotkniętych przemocą domową"
        },        
    ],
    actualPath: "/petycja",
    login: "",
    password: ""
}

export default messageState;